import { useFeatureEarningCalculationQuery } from 'generated/sanity-graphql';

export const useFeaturesEarningCalculations = () => {
  const { data, loading } = useFeatureEarningCalculationQuery({
    variables: { id: 'earningCalculation' },
  });

  return {
    data: data?.EarningCalculation,
    loading,
  };
};
